import * as React from 'react';
import type {
  IInputAttributes,
  IInputOptions,
} from '@components/Webform/WebformContent/interfaces';
import type { InputProps } from './interfaces';

const Input: React.FunctionComponent<InputProps> = ({
  inputAttributes,
}): any => {
  if (inputAttributes.type === 'webform_actions') {
    inputAttributes.value =
      inputAttributes.lang === 'FR' ? 'Envoyer' : 'Absenden';
    inputAttributes.type = 'submit';
    inputAttributes.name = 'op';
    inputAttributes.id = 'edit-submit';
    delete inputAttributes.title;
  }
  const generateCheckboxes = () => {
    if (
      (inputAttributes.type === 'checkboxes' && inputAttributes.options) ||
      (inputAttributes.type === 'radios' && inputAttributes.options)
    ) {
      return inputAttributes.options.map(
        (option: IInputOptions, index: number) => {
          const merged: IInputAttributes & IInputOptions = {
            ...inputAttributes,
            ...option,
          };
          const [title, desc] = merged.title.split('--');
          merged.desc = desc;
          merged.title = title ?? '';
          merged.id = `${merged.id}-${merged.value}`.replace('_', '-');
          merged.type === 'checkboxes'
            ? (merged.type = 'checkbox')
            : (merged.type = 'radio');
          merged.type === 'checkboxes'
            ? (merged.name = `${inputAttributes.name}[${merged.value}]`)
            : (merged.name = inputAttributes.name);
          delete merged.options;
          delete merged.__typename;
          return (
            <div key={`input-${merged.id}-div${index}`}>
              <input {...merged} key={`input-${merged.id}-${index}`} />
              <label
                htmlFor={merged.id}
                key={`input-${merged.id}-label${index}`}
              >
                {merged.title}
              </label>
              {merged.desc ? (
                <div
                  className="input--desc"
                  key={`input-${merged.id}-dsc${index}`}
                >
                  {merged.desc}
                </div>
              ) : null}
            </div>
          );
        },
      );
    }
  };
  return (
    <div>
      {inputAttributes.type === 'checkboxes' ||
      inputAttributes.type === 'radios' ? (
        <div id={inputAttributes.id}>{generateCheckboxes()}</div>
      ) : (
        <label htmlFor={inputAttributes.id}>{inputAttributes.title}</label>
      )}
      {inputAttributes.type === 'checkboxes' ||
      inputAttributes.type === 'radios' ? null : (
        <input {...inputAttributes} />
      )}
    </div>
  );
};

export default Input;
